import React from 'react'

import { Title, Text } from 'components/typo'
import Image from 'components/shared/Image'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const CirclePictureContent = ({
  className,
  logo,
  title,
  description,
  forwardRef,
  level
}) => {
  return (
    <div ref={forwardRef} className={cx(css.CirclePictureContent, className)}>
      {/* TODO Add level icon or badge */}
      {level && <div />}

      {logo && (
        <Image className={css.logo} forcedRatio={0.4} fit="contain" {...logo} />
      )}

      {title && (
        <Title className={css.title} size="smaller">
          {title}
        </Title>
      )}

      {description && (
        <Text className={css.description} theme="gray" size="small">
          {description}
        </Text>
      )}
    </div>
  )
}

export default CirclePictureContent
